import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import i18n from '../../../utils/i18n';
import Button from '@adsk/bim360-matrix-react-button';
import Loader from '@adsk/bim360-matrix-react-loader';
import EmptyState from '@adsk/bim360-matrix-react-empty-state';
import IssueTypesAdminCreateModalContainer from './IssueTypesAdminCreateModalContainer';
import IssueTypesAdminChangeStatusModal from './IssueTypesAdminChangeStatusModal';
import IssueTypeEditModalContainer from './IssueTypeEditModalContainer';
import {FIELD_TRACK_EVENT, issueTypesAdminVisit} from '../../../utils/analytics-helpers';
import IssueTypesAddAttributesModalContainer from './IssueTypesAddAttributesModalContainer';
import IssueTypesAddAttributesLeaveModalContainer from './IssueTypesAddAttributesLeaveModalContainer';
import IssueTypesAdminTableContainer from './IssueTypesAdminTableContainer';
import IssueTypesAdminChangeActiveStatusModal from './IssueTypesAdminChangeActiveStatusModal';

class IssueTypesAdmin extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      createIssueTypeModalOpen: false,
      changeStatusModalOpen: false,
      shouldOpenAddAttributesModal: false,
      highlightLastRow: false,
      changeActiveStatusModalOpen: false
    };

    this.openEditModal = this.openEditModal.bind(this);
    this.closeEditModal = this.closeEditModal.bind(this);
    this.closeCreateAttributesModal = this.closeCreateAttributesModal.bind(this);
    this.closeLeaveCreateAttributesModal = this.closeLeaveCreateAttributesModal.bind(this);
    this.onStatusChange = this.onStatusChange.bind(this);
  }

  componentWillMount() {
    //MixPanel Event - when user enters issue types admin page
    this.props.trackEvent(issueTypesAdminVisit(), FIELD_TRACK_EVENT);
  }

  fetchIssuesCustomizationMetadata() {
    this.props.fetchIssuesCustomizationMetadata();
  }

  onStatusChange(issueType) {
    const {isActive, parentId} = issueType;
    const parent = parentId ? this.props.data[parentId] : null;
    if (!isActive && parent && parent.isActive === false) {
      this.setState({changeStatusModalOpen: true, editedSubType: issueType});
    } else if (this.props.ffShowDisableTemplatesModal && isActive) {
      this.setState({changeActiveStatusModalOpen: true, currentIssueType: issueType});
    } else {
      this.setStatus(issueType);
    }
  }

  setStatus(issueType) {
    const {id, isActive, parentId} = issueType;
    this.props.updateIssueTypeStatusAction(id, !isActive, parentId);
  }

  openCreateIssueTypeModal() {
    this.setState({createIssueTypeModalOpen: true});
  }

  openEditModal({rowData: issueType}) {
    if (!issueType.isNewSubType) {
      this.props.selectIssueTypeForEdit(issueType.id);
      this.props.showIssueTypesEditModalAction(true, false);
    }
  }

  closeEditModal({isExited = false, shouldOpenAddAttributesModal = false} = {}) {
    if (!isExited) {
      this.setState({shouldOpenAddAttributesModal});
      this.props.showIssueTypesEditModalAction(false, shouldOpenAddAttributesModal);
    } else if (this.state.shouldOpenAddAttributesModal) {
      this.props.showIssueTypesAddAttributesModalAction(true);
      this.setState({shouldOpenAddAttributesModal: false});
    }
  }

  closeCreateAttributesModal({isExited = false, shouldOpenLeaveAddAttributesModal = false} = {}) {
    if (!isExited) {
      this.setState({shouldOpenLeaveAddAttributesModal});
      this.props.showIssueTypesAddAttributesModalAction(false);
    } else if (this.state.shouldOpenLeaveAddAttributesModal) {
      this.props.showIssueTypesLeaveAddAttributesModalAction(true);
      this.setState({shouldOpenLeaveAddAttributesModal: false});
    } else {
      this.props.showIssueTypesEditModalAction(true);
    }
  }

  closeLeaveCreateAttributesModal({isExited = false, shouldOpenAddAttributesModal = true} = {}) {
    if (!isExited) {
      this.setState({shouldOpenAddAttributesModal});
      this.props.showIssueTypesLeaveAddAttributesModalAction(false);
    } else if (this.state.shouldOpenAddAttributesModal) {
      this.props.showIssueTypesAddAttributesModalAction(true);
      this.setState({shouldOpenAddAttributesModal: false});
    } else {
      this.props.changeLocationAction('/admin/issueAttributes/new');
    }
  }

  onIssueTypeCreate() {
    this.props.scrollDown();
    this.setState({highlightLastRow: true}, () => {
      setTimeout(() => {
        this.setState({highlightLastRow: false});
      }, 4000);
    });
  }

  _renderTopButtons() {
    return (
      <div className="IssueTypesAdmin__buttons">
        <Button styleType={Button.StyleType.PRIMARY} onClick={this.openCreateIssueTypeModal.bind(this)}>
          {i18n.t('issueTypes.buttons.create')}
        </Button>
      </div>
    );
  }

  _renderTable() {
    return (
      <IssueTypesAdminTableContainer
        onStatusChange={this.onStatusChange}
        openEditModal={this.openEditModal}
        scrollDown={this.props.scrollDown}
        highlightLastRow={this.state.highlightLastRow}
      />
    );
  }

  _renderTryAgain() {
    return (
      <Button
        className="IssueTypesAdmin__empty-state-footer"
        onClick={this.fetchIssuesCustomizationMetadata.bind(this)}
        styleType={Button.StyleType.INLINE_LINK}
      >
        {i18n.t('adminPages.emptyState.tryAgain')}
      </Button>
    );
  }

  _renderEmptyState() {
    return (
      <EmptyState
        icon={EmptyState.Icons.CONE}
        className="IssueTypesAdmin__empty-state"
        text={i18n.t('adminPages.emptyState.didntLoad')}
        footer={this._renderTryAgain()}
      />
    );
  }

  onCreateIssueTypeModalClose() {
    this.setState({createIssueTypeModalOpen: false});
  }

  _renderCreateIssueTypeModal() {
    return (
      <IssueTypesAdminCreateModalContainer
        container={this}
        isOpen={this.state.createIssueTypeModalOpen}
        onCreate={this.onIssueTypeCreate.bind(this)}
        onModalClose={this.onCreateIssueTypeModalClose.bind(this)}
      />
    );
  }

  onChangeStatusModalClose() {
    this.setState({changeStatusModalOpen: false, editedSubType: null});
  }

  _renderChangeStatusModal() {
    return (
      <IssueTypesAdminChangeStatusModal
        container={this}
        isOpen={this.state.changeStatusModalOpen}
        onModalClose={this.onChangeStatusModalClose.bind(this)}
        onConfirm={this.setStatus.bind(this)}
        data={this.state.editedSubType}
      />
    );
  }

  _renderChangeActiveStatusModal() {
    return (
      <IssueTypesAdminChangeActiveStatusModal
        container={this}
        isOpen={this.state.changeActiveStatusModalOpen}
        onModalClose={() => this.setState({changeActiveStatusModalOpen: false, currentIssueType: null})}
        onConfirm={() => this.setStatus(this.state.currentIssueType)}
      />
    );
  }

  render() {
    const {isLoading, error, data, ffShowDisableTemplatesModal} = this.props;

    if (isLoading) {
      return <Loader />;
    }

    if (error || Object.keys(data).length === 0) {
      return this._renderEmptyState();
    }

    return (
      <div className="IssueTypesAdmin">
        {this._renderTopButtons()}
        {this._renderTable()}
        {this._renderCreateIssueTypeModal()}
        {this._renderChangeStatusModal()}
        {ffShowDisableTemplatesModal && this._renderChangeActiveStatusModal()}
        <IssueTypeEditModalContainer container={this} closeModal={this.closeEditModal} />
        <IssueTypesAddAttributesModalContainer container={this} closeModal={this.closeCreateAttributesModal} />
        <IssueTypesAddAttributesLeaveModalContainer
          container={this}
          closeModal={this.closeLeaveCreateAttributesModal}
        />
      </div>
    );
  }
}

IssueTypesAdmin.displayName = 'IssueTypesAdmin';

IssueTypesAdmin.propTypes = {
  fetchIssuesCustomizationMetadata: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired,
  isLoading: PropTypes.bool,
  error: PropTypes.bool,
  updateIssueTypeStatusAction: PropTypes.func.isRequired,
  trackEvent: PropTypes.func.isRequired,
  changeLocationAction: PropTypes.func.isRequired,
  selectIssueTypeForEdit: PropTypes.func.isRequired,
  showIssueTypesEditModalAction: PropTypes.func.isRequired,
  showIssueTypesAddAttributesModalAction: PropTypes.func.isRequired,
  showIssueTypesLeaveAddAttributesModalAction: PropTypes.func.isRequired,
  scrollDown: PropTypes.func.isRequired,
  ffShowDisableTemplatesModal: PropTypes.bool.isRequired
};

export default IssueTypesAdmin;
